<template>
    <div class="flex-row mt-5 animated fadeIn">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col sm="9" md="9" lg="5" xl="5">
                    <b-card-group>
                        <b-card no-body class="p-3">
                            <b-card-body>
                                <div class="text-center">
                                    <img
                                        src="static/img/fasa-logo.png"
                                        class="rounded mb-4"
                                        alt="SFC"
                                    />
                                    <strong><h2>FASAWeb</h2></strong>
                                    <br />
                                </div>
                                <p class="text-muted">
                                    Entre com suas credenciais
                                </p>
                                <app-erros-box
                                    :erros="erros"
                                    v-if="erros.length > 0"
                                ></app-erros-box>
                                <b-form>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend
                                            ><b-input-group-text
                                                ><i
                                                    class="icon-user"
                                                ></i></b-input-group-text
                                        ></b-input-group-prepend>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Usuário"
                                            v-model="login.usuario"
                                            autocomplete="username"
                                        />
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend
                                            ><b-input-group-text
                                                ><i
                                                    class="icon-lock"
                                                ></i></b-input-group-text
                                        ></b-input-group-prepend>
                                        <input
                                            type="password"
                                            class="form-control"
                                            placeholder="Senha"
                                            v-model="login.senha"
                                            @keypress.enter="entrar()"
                                            autocomplete="current-password"
                                        />
                                    </b-input-group>
                                </b-form>
                                <b-row>
                                    <b-col>
                                        <b-button
                                            variant="primary"
                                            class="px-4"
                                            @click="entrar()"
                                            >Entrar</b-button
                                        >
                                    </b-col>
                                    <!-- <b-col cols="6" class="text-right">
                    <b-button variant="link" class="px-0">Forgot password?</b-button>
                  </b-col> -->
                                </b-row>
                                <b-row class="mt-4 text-center">
                                    <b-col>
                                        <span class="mx-auto"
                                            ><strong
                                                >v{{ versao }}</strong
                                            ></span
                                        >
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                        <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%" v-show="!processando">
              <b-card-body class="text-center">
                <div>
                  <h2>Inscreva-se!!!</h2>
                  <p>Solicite seu cadastro clicando no botão abaixo.</p>
                  <b-button variant="primary" class="active mt-3">Solicitar Acesso</b-button>
                </div>
              </b-card-body>
            </b-card> -->
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import LoginServicos from './LoginServicos'

export default {
    name: 'Login',
    data() {
        return {
            login: {
                usuario: '',
                senha: ''
            },
            erros: [],
            versao: process.env.APP_VERSION
        }
    },
    methods: {
        entrar() {
            let loginDto = {
                usuario: this.login.usuario.toLowerCase(),
                senha: this.login.senha
            }
            this.$store.dispatch('addRequest')
            LoginServicos.login(loginDto).then((data) => {
                if (data) {
                    if (data.success) {
                        this.$store.dispatch('login', data.data)
                        this.processarRota()
                    } else {
                        this.erros = data.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        processarRota() {
            if (this.$store.getters.usuario.asplFlag === 'True') {
                this.$router.push('/atualizarsenha')
            } else if (this.$temAcesso('CRED-CART-00')) {
                this.$router.push({
                    name: 'Credores_Carteiras'
                })
            } else {
                this.$router.push('/')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/modulos/login/Login.vue